import { FPageBlock } from '../../mdl/f-page-block';
import { UICheckbox } from '../../ui/component/toggle';
import { $el } from '../../ui/elements';
import { $on } from '../../y/events';
import { $form } from '../../y/form';
import { EDBlockSpec, EDBlock } from '../block';
import { EDBlockContainer } from '../editor';
import { EDI18NInput } from '../input';
import { $page_values } from './values';

export const ed_page_text_block: EDBlockSpec<FPageBlock> = {
    key: 'text',
    editor_block: class extends EDBlock {
        constructor(container: EDBlockContainer) {
            const columns = new UICheckbox({ title: 'Columns' });
            const narrow = new UICheckbox({ title: 'Narrow' });
            const hug = new UICheckbox({ title: 'Hug' });

            const properties = $el.DIV('l-form', [columns, narrow, hug]);

            const text = new EDI18NInput({ multiline: true, styleable: true, formats: $page_values.default_formats, default_format: 'text', fields: container.editor.fields, images: 'page' });

            super($form({ text, columns, narrow, hug }), container, 'Text', properties);

            this.classList.add('w-block', 'b', 'b-block');
            this.ui_add(text);

            $on(columns, 'value', v => {
                this.classList.toggle('u-columns', !!v);
            });
            $on(narrow, 'value', v => {
                this.classList.toggle('w-narrow', !!v);
            });
            $on(hug, 'value', v => {
                this.classList.toggle('w-hug', !!v);
            });
        }
    },
};
